import { bootProfileSession } from '@/save/profileSession';
import { createAppShell } from '@/app/appShell';
import { openDiagnosticsIfAsked } from '@/diag/diagGate';

// The save is opened before anything is drawn, because who you are is the first thing the menu
// shows. Everything about that open is fallible and none of it is fatal: `bootProfileSession`
// answers with a session either way, so a browser with no storage still reaches a game.
// Before the save, because the save is fallible and the diagnostics are what explains a boot that
// does not finish. Nothing is fetched unless `?diag=1` asked for it.
openDiagnosticsIfAsked();

void bootProfileSession().then((profile) => {
  createAppShell(document.body, profile).start();
});
